var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#283EB4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0625 70.75L40.5416 66.1667L46.4791 49.8125C47 50.2986 47.5645 50.7069 48.1729 51.0375C48.7812 51.3681 49.4319 51.6194 50.125 51.7917L44.3958 67.5208L41.0625 70.75ZM62.9375 70.75L59.6041 67.5208L53.875 51.7917C54.5694 51.6181 55.2208 51.366 55.8291 51.0354C56.4375 50.7049 57.0013 50.2972 57.5208 49.8125L63.4583 66.1667L62.9375 70.75ZM52 49.9167C50.2638 49.9167 48.7882 49.309 47.5729 48.0937C46.3576 46.8785 45.75 45.4028 45.75 43.6667C45.75 42.3125 46.1409 41.1062 46.9229 40.0479C47.7048 38.9896 48.7027 38.2514 49.9166 37.8333V33.25H54.0833V37.8333C55.2986 38.25 56.2972 38.9882 57.0791 40.0479C57.8611 41.1076 58.2513 42.3139 58.25 43.6667C58.25 45.4028 57.6423 46.8785 56.427 48.0937C55.2118 49.309 53.7361 49.9167 52 49.9167ZM52 45.75C52.5902 45.75 53.0854 45.55 53.4854 45.15C53.8854 44.75 54.0847 44.2556 54.0833 43.6667C54.0833 43.0764 53.8833 42.5819 53.4833 42.1833C53.0833 41.7847 52.5888 41.5847 52 41.5833C51.4097 41.5833 50.9152 41.7833 50.5166 42.1833C50.118 42.5833 49.918 43.0778 49.9166 43.6667C49.9166 44.2569 50.1166 44.7521 50.5166 45.1521C50.9166 45.5521 51.4111 45.7514 52 45.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 38,
    fill: "white",
    transform: "translate(40 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.4d7e3e070299c9ab16c7952362213b2d.svg";
export { ForwardRef as ReactComponent };